// import React from "react";
import { useState, useContext, useEffect } from "react";
import useOneVOneContract from "../../Hooks/OneVOneContract";
import { useLocation, useNavigate } from "react-router-dom";
// import errorBack from "../Error/images/error-back1.png"
import { useAuthContext } from "../../AuthContext";
import { PaymentValidation } from "../../component/Context/noteContext";

export const PlayerMatchLogic = () => {
  const props = useLocation().state;

  const { isAuthenticated } = useAuthContext();

  const location = useLocation();
  const { GameId, paymentStarted, scoreToBeat, opponentAddress } =
    useOneVOneContract();
  const [playGame, setPlayGame] = useState(!!location?.state?.gameReady);
  const [userId, setUserId] = useState();
  const [opponentId, setOpponentId] = useState();
  const [opponentScore, setOpponentScore] = useState(-1);
  const {
    paymentValidation,
    setPaymentValidation,
    transaction,
    setTransaction,
  } = useContext(PaymentValidation);

  let auth_navigate = useNavigate();

  useEffect(() => {
    if (location?.state?.practice === true) {
      console.log("practice", location?.state?.practice);
      playHandler();
    } else if (!isAuthenticated) {
      localStorage.setItem("transaction", false);
      setTransaction(false);
      localStorage.setItem("gameId", -1);
      localStorage.setItem("entryId", -1);
    } else {
      if (isAuthenticated && transaction === true) {
        playHandler();
      }
    }
  }, [isAuthenticated, transaction]);
  useEffect(() => {
    // console.log('props', location.state, location.state.value)

    // let transaction = JSON.parse(localStorage.getItem("transaction"));
    let user_id =
      localStorage.getItem("user_id") ||
      "0x8fC73D9D27a730d4826E41babF76ee2D25f4736A";
    user_id = user_id?.slice(0, 10).concat("...");
    setUserId(user_id);

    if (
      (transaction == null || transaction === false) &&
      location.state &&
      isAuthenticated
    ) {
      GameId(
        location?.state?.type,
        location?.state?.value,
        location?.state?.name,
        location?.state?.practice,
        location?.state?.isCustomBet,
        location?.state?.gameType,
        location?.state?.direct
      );
    }

    if (opponentAddress) {
      setOpponentId(opponentAddress.slice(0, 10).concat("..."));
    } else {
      setOpponentId("0x00000000...");
    }
    if (scoreToBeat > 0) {
      // console.log("score to beat :", scoreToBeat);
      setOpponentScore(scoreToBeat);
    }
  }, [opponentAddress, scoreToBeat]);

  const playHandler = async () => {
    setPlayGame(true);
  };
  return {
    GameId,
    paymentStarted,
    scoreToBeat,
    opponentAddress,
    playGame,
    setPlayGame,
    setUserId,
    setOpponentId,
    setOpponentScore,
    paymentValidation,
    setPaymentValidation,
    transaction,
    setTransaction,
    props,
    location,
  };
};
